import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'

export const communityGardenSeedlingObject = z.object({
  id: z.string().uuid(),
  communityGardenId: z.string().uuid(),
  type: z.string().nullish(),
  quantity: z.number().int().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export type CommunityGardenSeedlingType = z.infer<typeof communityGardenSeedlingObject>

export const propertyMap = {
  id: sql`community_garden_seedling.id`,
  communityGardenId: sql`community_garden_seedling.community_garden_id`,
  type: sql`community_garden_seedling.type`,
  quantity: sql`community_garden_seedling.quantity`,
  createdAt: sql`community_garden_seedling.created_at`,
  updatedAt: sql`community_garden_seedling.updated_at`,
  deletedAt: sql`community_garden_seedling.deleted_at`,
}

export default communityGardenSeedlingObject
